import { withDependencies, named } from '@wix/thunderbolt-ioc'
import {
	SiteFeatureConfigSymbol,
	BrowserWindowSymbol,
	CurrentRouteInfoSymbol,
	Props,
	IPropsStore,
	IStructureAPI,
	StructureAPI,
	IAppWillLoadPageHandler,
} from '@wix/thunderbolt-symbols'
import { HtmlEmbeds, Window } from './types'
import { name } from './symbols'
import { ICurrentRouteInfo } from 'feature-router'
import { INavigationManager, NavigationManagerSymbol } from 'feature-navigation-manager'
import { handleCodeEmbeds } from './codeEmbedApi'

const codeEmbedFactory = (
	htmlEmbeds: HtmlEmbeds,
	window: Window,
	currentRouteInfo: ICurrentRouteInfo,
	navigationManager: INavigationManager,
	props: IPropsStore,
	structureAPI: IStructureAPI
): IAppWillLoadPageHandler => {
	return {
		async appWillLoadPage({ pageId, contextId }) {
			if (navigationManager.isFirstNavigation()) {
				return
			}

			const wrapperId = structureAPI.getPageWrapperComponentId(pageId, contextId)

			const addCodeEmbeds = handleCodeEmbeds(
				htmlEmbeds,
				pageId,
				window,
				currentRouteInfo.getPreviousRouterInfo()?.pageId
			)

			props.update({
				[wrapperId]: {
					codeEmbedsCallback: () => addCodeEmbeds(),
				},
			})
		},
	}
}

export const CodeEmbed = withDependencies(
	[
		named(SiteFeatureConfigSymbol, name),
		BrowserWindowSymbol,
		CurrentRouteInfoSymbol,
		NavigationManagerSymbol,
		Props,
		StructureAPI,
	],
	codeEmbedFactory
)
